export interface Env {
  apiBaseUrl: string;
}

/**
 * Muhitni tekshiradi. Prod build localhost'ga qarab qolsa, har bir so'rov jim
 * yiqiladi — shuning uchun ilova birinchi soniyadayoq baqiradi.
 */
export function readEnv(
  source: Partial<Record<string, string | boolean | undefined>>,
  isProd: boolean,
): Env {
  const raw = source.VITE_API_BASE_URL;
  const apiBaseUrl = typeof raw === "string" ? raw.trim().replace(/\/$/, "") : "";
  if (!apiBaseUrl) throw new Error("VITE_API_BASE_URL berilmagan (.env.example ga qarang).");
  if (!/^https?:\/\//.test(apiBaseUrl)) {
    throw new Error("VITE_API_BASE_URL http(s):// bilan boshlanishi kerak.");
  }
  if (isProd && /\/\/(localhost|127\.0\.0\.1)([:/]|$)/.test(apiBaseUrl)) {
    throw new Error("Prod build localhost API ga qaramasligi kerak.");
  }
  return { apiBaseUrl };
}

export const env: Env = readEnv(import.meta.env, import.meta.env.PROD);
